import type { EnterpriseSettings } from "metabase-types/api";

import { Api } from "./api";
import { invalidateTags, tag } from "./tags";

type SamlSettings = Pick<
  EnterpriseSettings,
  | "saml-enabled"
  | "saml-user-provisioning-enabled?"
  | "saml-attribute-email"
  | "saml-attribute-firstname"
  | "saml-attribute-lastname"
  | "saml-identity-provider-uri"
  | "saml-identity-provider-issuer"
  | "saml-identity-provider-certificate"
  | "saml-application-name"
  | "saml-keystore-password"
  | "saml-keystore-alias"
  | "saml-keystore-path"
  | "saml-attribute-group"
  | "saml-group-sync"
>;

export const samlApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    updateSaml: builder.mutation<void, Partial<SamlSettings>>({
      query: (settings) => ({
        method: "PUT",
        url: "/api/saml/settings",
        body: settings,
      }),
      invalidatesTags: (_, error) =>
        invalidateTags(error, [tag("session-properties")]),
    }),
  }),
});

export const { useUpdateSamlMutation } = samlApi;
